<template>
  <!-- 内容区 -->
  <div class="news-detail">
    <!-- banner -->
    <div class="banner-home banner-small">
      <div class="container">
        <img src="../assets/images/title-news.svg" class="banner-title" />
      </div>
    </div>
    <div class="container">
      <div class="content-box">
        <div class="news-title">
          {{ articleInfo.title }}
        </div>
        <div class="news-date">{{ articleInfo.created_at }}</div>
        <div class="content">
          <div id="vidro-content" v-show="articleInfo.vid"></div>
          <p>
            <img :src="articleInfo.cover" />
          </p>
          <p>
            {{ articleInfo.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articleDetail } from "@/network/API.js";
import { Base64 } from "js-base64";
import "../utils/txplayer";
export default {
  components: {},
  data() {
    return {
      articleInfo: {},
      player: null
    };
  },
  async created() {
    if (this.$route.params.id) {
      let res = await articleDetail(this.$route.params.id);
      res.content = Base64.decode(res.content);
      this.articleInfo = res;
      // this.articleInfo.vid = "e33086ydak8";
      if (this.articleInfo.vid) {
        this.playerInit(res.vid);
      }
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    playerInit(vid) {
      //调用且传腾讯视频的id即可
      this.player = new Txplayer({
        containerId: "vidro-content",
        vid: vid,
        width: "100%",
        height: screen.availHeight / 3,
        autoplay: true
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue